export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'